import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { CustomConfirmModalComponent } from "../shared-component/custom-confirm-modal/custom-confirm-modal.component";
const ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false
};

export function trcQuest(fForm: any): any {
    let isValid = false;
    const ssn = fForm.get("SSN")?.value ?? ""
    const fein = fForm.get("FEIN")?.value ?? ""
    if ((ssn.length > 0) && (fein.length > 0)) {
        isValid = false;
        fForm.get("SSN")?.setErrors({ 'bothSsnFein': true })
        fForm.get("FEIN")?.setErrors(null)
        return;
    }
    if (ssn?.length !== 0) {
        if (!new RegExp(/^(?!000)[0-9]\d{2}-(?!00)\d{2}-(?!0000)\d{4}$/).test(ssn) || (ssn.substring(0, 3) === '666')) {
            fForm.get("SSN")?.setErrors({ 'ssnError': true })
            fForm.get("FEIN")?.setErrors(null)
            return;
        }
    }
    if (fein?.length !== 0) {
        if (!new RegExp(/^\d{2}-\d{7}$/).test(fein)) {
            fForm.get("SSN")?.setErrors(null)
            fForm.get("FEIN")?.setErrors({ 'feinError': true })
            return;
        }
    }
    if (new RegExp(/^(?!000)[0-9]\d{2}-(?!00)\d{2}-(?!0000)\d{4}$/).test(ssn) && (ssn.substring(0, 3) !== '666')) {
        isValid = true;
    }
    if (new RegExp(/^\d{2}-\d{7}$/).test(fein)) {
        isValid = true;
    }
    if (!isValid) {
        fForm.get("SSN")?.setErrors({ 'oneOfSsnFein': true })
        fForm.get("FEIN")?.setErrors(null)
        return;
    }
    fForm.get("SSN")?.setErrors(null)
    fForm.get("FEIN")?.setErrors(null)
}
export function submitForm(fForm: any, model: NgbModal): boolean {
    const inputElements = document.getElementsByTagName("input");
    const isValid = validateBusFields(fForm, model, inputElements);
	trcQuest(fForm);
    if (isValid && fForm.get("SSN")?.valid && fForm.get("FEIN")?.valid) {
        return true;
    } else {
        return false;
    }
}

export function validateBusFields(fForm: any, model: NgbModal, target: HTMLCollectionOf<HTMLInputElement>): boolean {
    let professionSelected = false;
    let reqFieldMissing = false;
    let isValid = false;
	let isinValid = true;
    let sOldName = "";
    const inputElements = target
    for (let i = 0; i < inputElements.length; i++) {
        const data = inputElements[i].name
        const answer = fForm.get(inputElements[i].name)?.value
        if ((sOldName !== inputElements[i].name) && (inputElements[i].type === "radio")) {
            if (!professionSelected && answer === 'Y') {
                professionSelected = true;
            } else if (answer === "" ) {
                reqFieldMissing = true;
                // highlight the row
                (<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"
            }
			else if (answer === undefined) {
                reqFieldMissing = true;
                // highlight the row
                (<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"
            }
			

		else{
	(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#fff"
			}
            sOldName = inputElements[i].name;
        } else if (inputElements[i].type === "text" && (!(inputElements[i].name==='FEIN' ||inputElements[i].name==='SSN'))) {	
				if(answer === ""){
					
					
					
						reqFieldMissing=true;
						(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"
					
				}
				else if(!validateTextField(inputElements[i]) ){
					isinValid=false;
					(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#faa"	
				}else {
					(<HTMLElement>inputElements[i].parentNode?.parentNode?.parentNode).style.backgroundColor = "#fff"
				}
					
			}
    }
    if (reqFieldMissing) {
        const title = "Confirmation"
        const body = "Questions in highlighted rows are required and have not been answered.  Please provide answers."
        displayAlert(title, body, model)

    } else if (!professionSelected) {
        const title = "Confirmation"
        const body = "Please do not use the website to register if you do not meet all of the criteria.  Since the business does not engage in any of the listed business activities, you can not use the website.";
        displayAlert(title, body, model)
    } else if (!isinValid) {
			const title = "Confirmation"
        	const body = "The highlighted rows are required and only numeric characters are allowed.  " +
						 "Please correct the answer."
        	displayAlert(title, body, model)
	}else {

        isValid = true;

    }
    return isValid;
}

/*export function jumpToNxtPagee(): void{
	const title = "Confirmation"
        const body = "Questions in highlighted rows are required and have not been answered.  Please provide answers."
        displayAlert(title, body, model)
}*/

export function clearError(target: HTMLInputElement): void {
    (<HTMLElement>target.parentNode?.parentNode?.parentNode).style.backgroundColor = ""
}
export function validateTextField(event : any) : boolean{
		const inputElObj = event.value;
		const isValid = ( (inputElObj.length > 0) && (inputElObj.search(new RegExp("\\D")) === -1) ) ? true : false;
		return isValid;
	}

function displayAlert(title: string, body: string, model: NgbModal): void {
    const modalRef = model.open(CustomConfirmModalComponent, ngbModalOptions)
    modalRef.componentInstance.cModalTitle = title
    modalRef.componentInstance.cModalBody = body
}

export function processTextField(evnt : any, model : any) : void{ 
		//const inputElem = evnt.target ? evnt.target : evnt.srcElement; 
		if (validateTextField(evnt)) {	
			evnt.parentNode.parentNode.parentNode.style.backgroundColor = "";	
		} else {	
			evnt.parentNode.parentNode.parentNode.style.backgroundColor = "#faa";
			const title = "Confirmation"
        	const body = "The highlighted rows are required and only numeric characters are allowed. Please correct the answers."
        	displayAlert(title, body, model)
			
			//cancelEvent(evnt);
			
		}
		
	}